import * as React from "react";
import { PanelState, useAppSelector, PanelStateType } from "src/common";
import { ToggleLeftNav } from "src/components";
import { UiGuideNavigation, WorkflowNavigation } from "./";
import { RootState } from "src/store/configureStore";

type AllProps = {
  type: string;
  active_path?: string;
  handleAction: (state: PanelStateType) => void;
}
const components = {
  WorkflowNavigation,
  UiGuideNavigation
  // others ... to be added
};

function LeftNavigationComponent(props: AllProps) {
  const { type, active_path, handleAction } = props;
  const state = useAppSelector((state: RootState) => state.ui.left_nav_state);

  // Description:  Renders the specific links to the module
  const ComponentLinks = () => {
    const TagName = (components as any)[type];
    return (!!TagName) ?
      <TagName active_path={active_path} /> :
      <></>;
  };

  return <div className={`${state === PanelState.off ? " closed" : ""}`}>
    <div className="toggle-box">
      <ToggleLeftNav handleAction={handleAction} />
      <p> 
        Developer Tools 
        <small> Made By Your Intern </small> 
      </p>
    </div>
    <div className="left-navigation">
      <ComponentLinks />
    </div>
  </div>;
}

export default React.memo(LeftNavigationComponent);
